import styled from '@emotion/styled';

export const SideDrawerHeaderContainer = styled.div`
  margin: 16px 16px 30px;
  display: flex;
  justify-content: flex-end;
`;

export const SideDrawerFooterContainer = styled.div`
  z-index: inherit;
  position: absolute;
  display: flex;
  bottom: 0;
  width: 320px;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.1);
`;

export const SideDrawerContentContainer = styled.div`
  animation: none;
  width: 320px;
  height: 100%;
  overflow-y: scroll;
`;
